import type { Branded } from '@/utils/typing/branded.type';
import type { UserId } from './User.interface';
export interface DocumentManagementFile {
    fileId: DocumentManagementFileId;
    fileTypeId: DocumentManagementFileTypeId;
    extension: string;
    fileName: string;
    url: string;
    size: number;
    lastUpdatedBy: UserId;
    lastUpdatedAt: string;
}

export type DocumentManagementFileId = Branded<number, 'DocumentManagementFileId'>;
export type DocumentManagementFileTypeId = Branded<number, 'DocumentManagementFileTypeId'>;

export enum ConflictResolutionStrategy {
    NONE = 'NONE',
    CANCEL = 'CANCEL',
    REPLACE = 'REPLACE',
    KEEP_BOTH = 'KEEP_BOTH'
}
